import React, { useState, useEffect } from 'react';
import { TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
  initialNotes?: string | null;
};

export const SkipAssetModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  initialNotes
}) => {
  const { t } = useTranslation(['calibration', 'common']);
  const [reason, setReason] = useState(initialNotes || '');

  useEffect(() => {
    if (open) {
      setReason(initialNotes || '');
    }
  }, [open, initialNotes]);

  const handleConfirm = () => {
    onConfirm(reason);
  };

  const isReasonEmpty = reason.trim().length === 0;

  return (
    <Modal open={open} onClose={onClose} width="450px">
      <Modal.Header title={t('skipEquipment.title')} onClose={onClose} />
      <Modal.Content>
        <Typography variant="body1" gutterBottom>
          {t('skipEquipment.description')}
        </Typography>

        <TextField
          fullWidth
          multiline
          rows={4}
          label={t('skipEquipment.reasonLabel')}
          placeholder={t('skipEquipment.reasonPlaceholder')}
          value={reason}
          onChange={e => setReason(e.target.value)}
          disabled={isLoading}
          sx={{ mt: 2 }}
        />
      </Modal.Content>
      <Modal.Footer
        secondaryButton={{
          text: t('common:buttons.cancel'),
          onClick: onClose,
          variant: 'text'
        }}
        primaryButton={{
          text: isLoading
            ? t('skipEquipment.skipping')
            : t('skipEquipment.confirm'),
          onClick: handleConfirm,
          color: 'warning',
          variant: 'contained',
          disabled: isLoading || isReasonEmpty
        }}
      />
    </Modal>
  );
};
